const AGENTS_URL = `${process.env.API_V4_HOST}/_exclusive/agent-retention`;
const AGENTS_PUBLIC_URL = `${process.env.API_V4_HOST}/agent-retention`;

export const getUserState = $axios => $axios.$get(`${AGENTS_URL}/users/me`);
export const getUserFreebiesDetail = ($axios, userId) => $axios.$get(`${AGENTS_URL}/barang-vp-freebies/users/${userId}`);
export const postUserFreebiesReward = $axios => $axios.$post(`${AGENTS_URL}/barang-vp-freebies/users`);
export const getRouletteRewards = $axios => $axios.$get(`${AGENTS_URL}/barang-vp-freebies/rewards`);
export const getUserPoin = $axios => $axios.$get(`${AGENTS_PUBLIC_URL}/points/my-point`);
